export default "__VITE_ASSET__5b1526d1__"